export default "__VITE_PUBLIC_ASSET__256fe189__"